// extracted by mini-css-extract-plugin
module.exports = {"expandRecordPanel":"style_expandRecordPanel___muet"};